(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/modal/assets/javascripts/components/modal.js') >= 0) return;  svs.modules.push('/components/components/modal/assets/javascripts/components/modal.js');
"use strict";

function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != typeof t || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }

((svs, React, ReactDOM, PropTypes) => {
  const ReactSwiper = svs.components.ReactSwiper;
  const logger = new svs.core.log.Logger('react-modal usage');
  class Modal extends React.Component {
    constructor(props) {
      super(props);
      _defineProperty(this, "state", {
        entered: false,
        unmounted: !this.props.show
      });
      this.elem = document.createElement('div');
      document.body.appendChild(this.elem);
      if (this.props.onEscape && this.props.show) {
        this.addKeyboardListener();
      }
    }
    componentDidMount() {
      this._isMounted = true;
      if (this.props.show) {
        this.setState({
          entered: true
        });
      }
    }
    componentDidUpdate(prevProps, prevState) {
      const _this$props = this.props,
        show = _this$props.show,
        onEscape = _this$props.onEscape;
      const entered = show && !prevState.unmounted;
      const unmounted = !show && !prevState.entered;
      if (onEscape) {
        if (show && !this.keyListenerId) {
          this.addKeyboardListener();
        }
        if (!show && this.keyListenerId) {
          this.removeKeyboardListener();
        }
      }
      if (entered !== prevState.entered || unmounted !== prevState.unmounted) {
        const delay = !entered && unmounted ? 200 : 0;
        if (this.isUnMounting) {
          clearTimeout(this.timer);
        }
        this.isUnMounting = unmounted && !entered;
        this.timer = setTimeout(() => {
          if (!this._isMounted) {
            return;
          }
          requestAnimationFrame(() => {
            this.setState({
              entered,
              unmounted
            });
          });
        }, delay);
      }
    }
    componentWillUnmount() {
      document.body.removeChild(this.elem);
      this.removeKeyboardListener();
      this._isMounted = false;
      this.isUnMounting = false;
    }
    handleKeypress(event) {
      if (event.keyCode === svs.utils.keylistener.KEY_ESC) {
        this.props.onEscape();
      }
    }
    removeKeyboardListener() {
      svs.utils.keylistener.removeKeyboardListener(this.keyListenerId);
      this.keyListenerId = null;
    }
    addKeyboardListener() {
      this.keyListenerId = svs.utils.keylistener.addKeyboardListener(this.handleKeypress.bind(this));
    }
    renderModalWrapper() {
      const rightClickHandler = this.props.onRightButtonClick || this.props.rightButtonOnClick;
      const leftClickHandler = this.props.onLeftButtonClick || this.props.leftButtonOnClick;
      const hasButton = rightClickHandler || leftClickHandler;
      const classes = 'modal-container modal-animate-start react-modal-container'.concat(this.state.entered ? ' modal-animate-started' : '').concat(this.props.doubleWidth ? ' modal-double-width' : '').concat(this.props.classes ? " ".concat(this.props.classes) : '');
      return React.createElement("div", {
        className: classes,
        onClick: this.handleClick
      }, React.createElement("header", {
        className: "modal-header row f-uppercase ".concat(this.props.headerClass || 'header-default')
      }, hasButton && React.createElement("span", {
        className: "modal-header-button-left"
      }, leftClickHandler && React.createElement("button", {
        className: "btn btn-100 modal-button-left btn-transparent-".concat(this.props.buttonClassName),
        onClick: leftClickHandler,
        type: "button"
      }, this.props.leftButtonText)), React.createElement("h3", {
        className: "modal-header-title",
        id: "modal-header-title"
      }, React.createElement("span", {
        className: "js-top-center-content modal-header-title-content modal-title"
      }, this.props.title)), hasButton && React.createElement("span", {
        className: "modal-header-button-right"
      }, rightClickHandler && React.createElement("button", {
        className: "btn btn-100 modal-button-right btn-transparent-".concat(this.props.buttonClassName),
        onClick: rightClickHandler,
        type: "button"
      }, this.props.rightButtonText))), React.createElement("div", {
        className: "modal-content bg-white modal-content-buttons"
      }, React.createElement(ReactSwiper, {
        className: "padding-1"
      }, this.props.children)));
    }
    render() {
      if (this.state.unmounted) {
        return null;
      }
      return ReactDOM.createPortal(this.renderModalWrapper(), this.elem);
    }
  }
  Modal.defaultProps = {
    buttonClassName: 'default',
    classes: '',
    doubleWidth: false,
    headerClass: '',
    leftButtonOnClick: null,
    leftButtonText: 'Avbryt',
    onEscape: null,
    rightButtonOnClick: null,
    rightButtonText: 'Klar',
    show: true,
    title: ''
  };
  svs.components.react_modal = {
    Modal
  };
})(svs, React, ReactDOM, PropTypes);

 })(window);